import client from './client';





// 전체 카테고리 조회
export const getCategories = async () => {

    const response =

        await client.get(
            '/categories'
        );





    return response.data;
};





// 카테고리 등록
export const createCategory = async (

    name: string
) => {

    return await client.post(

        '/categories',

        {

            name
        }
    );
};





// 카테고리 수정
export const updateCategory = async (

    id: number,

    name: string
) => {

    return await client.put(

        `/categories/${id}`,

        {

            name
        }
    );
};





// 카테고리 삭제
export const deleteCategory = async (

    id: number
) => {

    return await client.delete(

        `/categories/${id}`
    );
};